import { render, staticRenderFns } from "./OptionsBar.vue?vue&type=template&id=0c665012&"
import script from "./OptionsBar.vue?vue&type=script&lang=js&"
export * from "./OptionsBar.vue?vue&type=script&lang=js&"
import style0 from "./OptionsBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports